/**
 * Transforms LCSC browser URLs into actual CDN URLs that can be fetched directly.
 *
 * LCSC browser URLs like `https://www.lcsc.com/datasheet/lcsc_datasheet_...pdf` don't work
 * for direct HTTP fetching. This function transforms them to the actual CDN URL format:
 * `https://wmsc.lcsc.com/wmsc/upload/file/pdf/v2/lcsc/...`
 *
 * @param url - The original URL (can be LCSC browser URL or any other URL)
 * @returns The transformed CDN URL if it's an LCSC datasheet URL, otherwise the original URL
 *
 * @example
 * ```typescript
 * const browserUrl = "https://www.lcsc.com/datasheet/lcsc_datasheet_2408141041_VBsemi-Elec-VBK3215N_C516947.pdf";
 * const cdnUrl = resolveLcscDatasheetUrl(browserUrl);
 * // Returns: "https://wmsc.lcsc.com/wmsc/upload/file/pdf/v2/lcsc/2408141041_VBsemi-Elec-VBK3215N_C516947.pdf"
 * ```
 */
export function resolveLcscDatasheetUrl(url) {
    try {
        const parsedUrl = new URL(url);
        const isLcsc = parsedUrl.hostname.includes("lcsc.com") && parsedUrl.pathname.includes("/datasheet/");
        if (!isLcsc) {
            return url;
        }
        const fileName = url.split("/").pop();
        if (!fileName) {
            return url;
        }
        return `https://wmsc.lcsc.com/wmsc/upload/file/pdf/v2/lcsc/${fileName.replace("lcsc_datasheet_", "")}`;
    }
    catch {
        // If URL parsing fails, return the original URL
        return url;
    }
}
//# sourceMappingURL=resolveLcscDatasheetUrl.js.map